import ApiClient from "../api-client";
import { EnvType } from "../services";
import {
  CreateExternalAccessRequest,
  UpdateExternalAccessRequest,
  ListExternalAccessesResponse,
  ValidateExternalAccessRequest,
  GetExternalAccessNoAuthResponse,
} from "../Types/access-models";
import { GenericResponseStd } from "../Types/generic-response-std";
import { default as IAccessApiClient, default as AccessApiClient } from "./access-api-client";

export default class AccessService {
  externalAccessApiClient: IAccessApiClient;

  constructor(envType: EnvType) {
    this.externalAccessApiClient = new AccessApiClient(new ApiClient(envType), envType);
  }

  async CreateExternalAccess(request: CreateExternalAccessRequest): Promise<GenericResponseStd> {
    return await this.externalAccessApiClient.CreateExternalAccess(request);
  }
  async UpdateExternalAccess(request: UpdateExternalAccessRequest): Promise<GenericResponseStd> {
    return await this.externalAccessApiClient.UpdateExternalAccess(request);
  }
  async RevokeExternalAccess(id: number): Promise<GenericResponseStd> {
    return await this.externalAccessApiClient.RevokeExternalAccess(id);
  }
  async ListExternalAccesses(): Promise<ListExternalAccessesResponse> {
    return await this.externalAccessApiClient.ListExternalAccesses();
  }
  async ListExternalAccessesByObjectId(objectId: number): Promise<ListExternalAccessesResponse> {
    return await this.externalAccessApiClient.ListExternalAccessesByObjectId(objectId);
  }
  async GetExternalAccessNoAuth(key: string): Promise<GetExternalAccessNoAuthResponse> {
    return await this.externalAccessApiClient.GetExternalAccessNoAuth(key);
  }
  async ValidateExternalAccess(request: ValidateExternalAccessRequest): Promise<GenericResponseStd> {
    return await this.externalAccessApiClient.ValidateExternalAccess(request);
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.externalAccessApiClient.GetApiUrl();
  }
}
